// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"06d122c1","796":"cd7b4700","952":"42e86c4a"}[chunkId] + ".chunk.js";
};